import { getEnv, RestHandler, getCsrfToken } from '@ctct/ctct-helpers';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1/contacts';
  }

  return `https://app${getEnv()}constantcontact.com/v1/contacts`;
};

const options = { headers: {} };
const token = getCsrfToken();

if (getEnv() !== 'local') {
  options.headers['X-CSRF-Token'] = token;
}

const restHandler = new RestHandler(getBaseUrl(), options);

const getContactsCount = () => restHandler.get(`/contacts?limit=0&status=active&include_count=true`);

export default { getContactsCount };
